/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
import PreviewCommandsBase from "bundle/commands/PreviewCommands";
import ServiceRegistry from "bundle/util/ServiceRegistry";
import searchApi from "app/api/SearchApi";

export default class PreviewCommands extends PreviewCommandsBase {
    static getClassName() {
        return "PreviewCommands";
    }

    _searchQuery(data) {
        return new Promise((resolve, reject) => {
            const appStore = ServiceRegistry.getService("AppStore");
            if (!appStore.getActionConfig("preview").enableSearchAPIs) {
                reject("Search APIs not enabled.");
                return;
            }
            this._publicAPIs.document.search(data.searchText)
                .then(searchObj => {
                    searchApi.updateSearchData(data.searchId, searchObj);
                    resolve();
                })
                .catch(error => reject(error));
        });
    }

    _getPDFMetadata() {
        return this._publicAPIs.document.getMetadata()
            .then(pdfMetadata => {
                const appStore = ServiceRegistry.getService("AppStore");
                const fileName = appStore.previewMetadata.fileName || "";
                const metadata = Object.assign(pdfMetadata, {
                    pdfTitle: pdfMetadata.pdfTitle || fileName.replace(".pdf", ""),
                });
                appStore.setPDFMetadata(metadata);
                return Promise.resolve(metadata);
            })
            .catch(() => Promise.reject("Unable to fetch metadata"));
    }
}
